import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73702dbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sticky-sidebar pb-1" }
const _hoisted_2 = { class: "card mb-2" }
const _hoisted_3 = { class: "card-body position-relative py-2" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { style: {"color":"#004761"} }
const _hoisted_7 = { class: "fw-normal" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Code: ")
const _hoisted_9 = { class: "ms-5" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Number of Students: ")
const _hoisted_11 = { class: "col text-end" }
const _hoisted_12 = { class: "fw-normal" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Language they know: ")
const _hoisted_14 = { class: "fw-normal" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Language they learn: ")
const _hoisted_16 = { class: "row g-3 mb-3 excercises classgroup" }
const _hoisted_17 = {
  key: 0,
  class: "col-lg-2"
}
const _hoisted_18 = { class: "card" }
const _hoisted_19 = { class: "card-header bg-light" }
const _hoisted_20 = { class: "row align-items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row flex-between-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "aling-middle align-items-center fs--1" }, " Add more than one to the same deadline and they will be all included together for that deadline date. ")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_23 = { class: "row flex-between-center" }
const _hoisted_24 = { class: "d-flex flex-md-row justify-content-evenly" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_DataTableStudents = _resolveComponent("DataTableStudents")!
  const _component_DataTableAssignments = _resolveComponent("DataTableAssignments")!
  const _component_SearchExercises = _resolveComponent("SearchExercises")!
  const _component_DataTableExercises = _resolveComponent("DataTableExercises")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h4", _hoisted_6, "Classgroup: " + _toDisplayString(_ctx.classGroup.name), 1),
                  _createElementVNode("p", _hoisted_7, [
                    _createElementVNode("span", null, [
                      _hoisted_8,
                      _createElementVNode("b", null, _toDisplayString(_ctx.classGroup.code), 1)
                    ]),
                    _createElementVNode("span", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("b", null, _toDisplayString(_ctx.classGroup.studentCount), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("b", null, _toDisplayString(_ctx.classGroup.languageMapping.pair.languageFromName), 1)
                  ]),
                  _createElementVNode("p", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("b", null, _toDisplayString(_ctx.classGroup.languageMapping.pair.languageToName), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_DataTableStudents, { classgroup: _ctx.classGroup }, null, 8, ["classgroup"]),
        _createVNode(_component_DataTableAssignments, { classgroup: _ctx.classGroup }, null, 8, ["classgroup"]),
        _createElementVNode("div", _hoisted_16, [
          (_ctx.showVerticalFilter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_SearchExercises, {
                  vertical: "",
                  "class-group": _ctx.classGroup,
                  onFilter: _ctx.filterExercises
                }, null, 8, ["class-group", "onFilter"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass({
          'col-lg-10': _ctx.showVerticalFilter,
          'col-lg': !_ctx.showVerticalFilter,
        })
          }, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("h4", null, "Assignments for Classgroup: " + _toDisplayString(_ctx.classGroup.name), 1)
                ]),
                _hoisted_21,
                (!_ctx.showVerticalFilter)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_SearchExercises, {
                            horizontal: "",
                            "class-group": _ctx.classGroup,
                            onFilter: _ctx.filterExercises
                          }, null, 8, ["class-group", "onFilter"])
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.exercises.length > 0)
                ? (_openBlock(), _createBlock(_component_DataTableExercises, {
                    key: 0,
                    "class-groups": _ctx.classGroups,
                    "class-group": _ctx.classGroup,
                    exercises: _ctx.exercises,
                    pagination: _ctx.pagination,
                    onChangePage: _ctx.getExercises
                  }, null, 8, ["class-groups", "class-group", "exercises", "pagination", "onChangePage"]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ])
      ], 64))
}